enum TemplateType {
  INTRO = 0,
  OUTRO = 1
}

export default TemplateType;
